import { Component, OnInit } from '@angular/core';
import { MessengerService } from '../services/messenger.service';
import { ModalHelperService } from '../services/modal-helper.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss'],
})
export class ContactPage implements OnInit {
  constructor(
    public messengerService: MessengerService,
    public modalHelper: ModalHelperService
  ) {}

  ngOnInit() {}
}
